import { Box, Dialog, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSIconCard from "../../../Components/IconCard/WSIconCard";
import { CardTopUp } from "./CardTopUp";
import { ClearKOT } from "./ClearKot";
import { CashIn } from "./CashIn";
import { CashOut } from "./CashOut";
import { NoSale } from "./NoSale";

interface FooterDialogProps {
  open: boolean;
  onClose: () => void;
}

export const OthersOperation: React.FC<FooterDialogProps> = React.memo(({ open, onClose }) => {
  const navigate = useNavigate();
  const [openCardTopUp, setOpenCardTopUp] = useState(false);  
  const [openClearKOT, setOpenClearKOT] = useState(false);  
  const [openCashIn, setOpenCashIn] = useState(false);  
  const [openCashOut, setCashOut] = useState(false);  
  const [openNoSale, setNoSale] = useState(false);  


  const handleClick = (path: string) => {
    navigate(path);
  };

  /**
 * Card TopUp dialogue
 */
  const handleCardTopUpClick = () => {
    onClose();                
    setOpenCardTopUp(true); 
  };
  const handleCardTopUpClose = () => {
    setOpenCardTopUp(false); 
  };

  /**
   * Clear KOT
   */
  const handleClearKotClick = () => {
    onClose();                
    setOpenClearKOT(true); 
  };
  const handleClearKotClose = () => {
    setOpenClearKOT(false); 
  };
 /**
   * Cash in
   */
 const handleCashInClick = () => {
  onClose();                
  setOpenCashIn(true); 
};
const handleCashInClose = () => {
  setOpenCashIn(false); 
};
 /**
   * cash out
   */
 const handleCashOutClick = () => {
  onClose();                
  setCashOut(true); 
};
const handleCashOutClose = () => {
  setCashOut(false); 
};

 /**
   * No sale
   */
 const handleNoSaleClick = () => {
  onClose();                
  setNoSale(true); 
};
const handleNoSaleClose = () => {
  setNoSale(false); 
};
  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            display: 'flex',
            justifyContent: 'center',
            margin: 0,  // Remove margin around the dialog
            top:8
          },
        }}>
        <DialogTitle sx={{ padding: 0 }}>
          <Grid sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px' }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', color: "green" }}>
              Other's Operation
            </Typography>
            <Grid sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <WSIcons.GTranslateIcon />
              <IconButton onClick={onClose}>
                <WSIcons.CloseIcon sx={{ backgroundColor: 'red', color: 'white' }} />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={3}>
              <WSIconCard icon={<WSIcons.Reservations sx={{ color: "green" }} />} name={"Reservation"} sx={{ height: "7rem",width:"12rem" }} onClick={() => handleClick('/reservationlist')} />
            </Grid>
            <Grid item xs={3}>
              <WSIconCard icon={<WSIcons.GroupsIcon sx={{ color: "green" }} />} name={"Waiting List"} sx={{ height: "7rem",width:"12rem" }} onClick={() => handleClick('/waitinglist')}/>
            </Grid>
            <Grid item xs={3}>
              <WSIconCard icon={<WSIcons.PaymentsIcon sx={{ color: "green" }} />} name={"Pay Outs"} sx={{ height: "7rem",width:"12rem" }}  onClick={() => handleClick('/payouts')}/>
            </Grid>
            <Grid item xs={3}>
              <WSIconCard icon={<WSIcons.Dollar sx={{ color: "green" }} />} name={"Misc.Sales"} sx={{ height: "7rem",width:"12rem" }} onClick={() => handleClick('/miscsales')}/>
            </Grid>
            <Grid item xs={3}>
            <WSIconCard icon={<WSIcons.PaymentsIcon sx={{color:"green"}}/>} name={"Account Payment"} sx={{height: "7rem",width:"12rem" }} onClick={() => handleClick('/accountlisting')}/>
          </Grid>
          <Grid item xs={3}>
            <WSIconCard icon={<WSIcons.RedoIcon sx={{color:"green"}}/>} name={"Take Table"} sx={{height: "7rem",width:"12rem" }} onClick={() => handleClick('/taketable')}/>
          </Grid>
          <Grid item xs={3}>
            <WSIconCard icon={<WSIcons.SyncIcon sx={{color:"green"}}/>} name={"Transfer Table"} sx={{height: "7rem",width:"12rem" }}  onClick={() => handleClick('/transfertable')}/>
          </Grid>
          <Grid item xs={3}>
            <WSIconCard icon={<WSIcons.CreditCardIcon sx={{color:"green"}}/>} name={"Card Top Up"} sx={{height: "7rem",width:"12rem" }} onClick={handleCardTopUpClick}/>
          </Grid>
          <Grid item xs={3}>
            <WSIconCard icon={<WSIcons.Hold sx={{color:"green"}}/>} name={"Clear Hold KOT/Receipt"} sx={{height: "7rem",width:"12rem" }} onClick={handleClearKotClick}/>
          </Grid>
          <Grid item xs={3}>
            <WSIconCard icon={<WSIcons.TokenIcon sx={{color:"green"}}/>} name={"Reset Token"} sx={{height: "7rem",width:"12rem" }} />
          </Grid>
          <Grid item xs={3}>
            <WSIconCard icon={<WSIcons.Cashin sx={{color:"green"}}/>} name={"Cash In"} sx={{height: "7rem",width:"12rem" }} onClick={handleCashInClick}/>
          </Grid>
          <Grid item xs={3}>
            <WSIconCard icon={<WSIcons.Cashin sx={{color:"green"}}/>} name={"Cash Out"} sx={{height: "7rem",width:"12rem" }} onClick={handleCashOutClick}/>
          </Grid>
          <Grid item xs={3}>
            <WSIconCard icon={<WSIcons.Cashin sx={{color:"green"}}/>} name={"No Sale"} sx={{height: "7rem",width:"12rem" }} onClick={handleNoSaleClick}/>
          </Grid>
                    
          </Grid>
        </DialogContent>
      </Dialog>
      <CardTopUp open={openCardTopUp}  onClose={handleCardTopUpClose} />
      <ClearKOT open={openClearKOT}  onClose={handleClearKotClose} />
      <CashIn open={openCashIn}  onClose={handleCashInClose} />
      <CashOut open={openCashOut}  onClose={handleCashOutClose} />
      <NoSale open={openNoSale}  onClose={handleNoSaleClose} />


    </>
  );
});
